import { GSEndpoint } from "../models/endpoint";
import { BaseScopes, Scope } from "../models/scopes";
import { User } from "../models/user";

interface UserI {
    id?: string;
    name: string;
    email: string;
    permissions: Scope[];
}

interface CreateUserI {
    name: string;
    defaultGroups: Scope[];
}

export class GetSelf extends GSEndpoint<{}, UserI> {
    constructor() {
        super("users/self", "GET", []);
    }

    override async request(user: Partial<User>): Promise<User> {
        const res = await super.makeRequest({}, user);
        const userScopes = new Set(res.permissions);
        return { ...res, permissions: userScopes } as User;
    }
}

export class GetUser extends GSEndpoint<{}, UserI> {
    constructor(user: string) {
        super("users/info/{user}", "GET", [], {}, [user]);
    }

    override async request(user: User): Promise<User> {
        const res = await super.makeRequest({}, user);
        const userScopes = new Set(res.permissions);
        return { ...res, permissions: userScopes } as User;
    }
}

export class PostUser extends GSEndpoint<Partial<UserI>> {
    constructor() {
        super("users/update", "POST", [BaseScopes.ADMIN]);
    }

    override async request(req: Partial<UserI>, user: User): Promise<{}> {
        return await super.makeRequest(req, user);
    }
}

export class CreateUser extends GSEndpoint<CreateUserI> {
    constructor() {
        super("users/create", "POST", []);
    }

    override async request(req: CreateUserI, user: Partial<User>): Promise<{}> {
        return await super.makeRequest(req, user);
    }
}
